import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { ReactNode } from "react";

interface RelatedLinksProps {
  children: ReactNode;
}

interface RelatedLinkProps {
  href: string;
  children: ReactNode;
}

export function RelatedLinks({ children }: RelatedLinksProps) {
  return (
    <div className="mt-10 pt-6 border-t border-border">
      <p className="text-xs font-medium text-text-faint uppercase tracking-widest mb-3">Related</p>
      <div className="flex flex-col gap-2">{children}</div>
    </div>
  );
}

export function RelatedLink({ href, children }: RelatedLinkProps) {
  const isExternal = href.startsWith("http");
  if (isExternal) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="group flex items-center gap-2 text-sm text-primary-text hover:text-primary transition-colors"
      >
        <ArrowRight
          size={13}
          aria-hidden="true"
          className="text-primary group-hover:translate-x-0.5 transition-transform"
        />
        {children}
        <span className="sr-only"> (opens in a new tab)</span>
      </a>
    );
  }

  return (
    <Link
      to={href}
      className="group flex items-center gap-2 text-sm text-primary-text hover:text-primary transition-colors"
    >
      <ArrowRight
        size={13}
        className="text-primary group-hover:translate-x-0.5 transition-transform"
      />
      {children}
    </Link>
  );
}
